import { FC } from "react";
import { observer } from "mobx-react";
import { Box, Card, VBox } from "@/components-v2/Box";
import { Button } from "@/components-v2/Button";
import { Checkbox } from "@/components-v2/Checkbox";
import Form from "@/components-v2/Form";
import { MTextInput } from "@/components-v2/TextInput";
import DefaultLayout from "@/containers/DefaultLayout";
import { useTranslation } from "@/stores/RootStoreContext";
import { Markdown } from "@/text/Markdown";
import { AcceptUserTermsViewProps } from "./acceptUserTermsDomain";

export const AcceptUserTermsView: FC<AcceptUserTermsViewProps> = observer(
  ({ fullName, infoMessage, emailModel, acceptedTermsModel, isAccepting, acceptUserTerms }) => {
    const { t } = useTranslation();
    return (
      <DefaultLayout withHeader={false} maxWidth={"sm"} fullheight>
        <VBox justifyContent={"center"} fullheight>
          <h1>{t("registerUser.welcome", { name: fullName })}</h1>
          <Card gap={"md"}>
            <p>{t(infoMessage)}</p>
            <p>{t("registerUser.whyEmail")}</p>
            <Form submitOnEnter onSubmit={acceptUserTerms}>
              <MTextInput label={t("registerUser.emailCaption")} model={emailModel} autofocus />
            </Form>
            <Checkbox
              id={"userTerms"}
              checked={acceptedTermsModel.value ?? false}
              onChange={acceptedTermsModel.toggle}
              label={
                <Markdown value={t("registerUser.agreeToTerms")} enableLinks disableLastMargin />
              }
            />
            {!acceptedTermsModel.isValid && (
              <Box fg={"error"}>{t("registerUser.agreeToTerms.validationError")}</Box>
            )}
            <div>
              <Button
                variant={"primary"}
                label={t("registerUser.completeUserRegistration")}
                loading={isAccepting}
                onClick={acceptUserTerms}
              />
            </div>
          </Card>
        </VBox>
      </DefaultLayout>
    );
  },
);
